import "@babel/polyfill";
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import Global from './global'
import 'antd-mobile/dist/antd-mobile.css';
import './static/styles/base.scss';
import './static/styles/border.scss'
import './static/font/iconfont.css'

ReactDOM.render(
  <Global/>,
  document.getElementById('root') as HTMLElement
);

